import AssetManagerComponent from '72cms-ui/components/AssetManagerComponent';
import LazyLoadingMultiSelectComponent from '72cms-ui/components/helpers/LazyloadingMultiSelectComponent';
import PageBuilderComponent from '72cms-ui/components/helpers/PageBuilderComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import OrderDetailComponent from '72cms-ui/components/helpers/OrderDetailComponent';
import MatrixInputComponent from '72cms-ui/components/helpers/MatrixInputComponent';
import MessageDetailComponent from '../components/MessageDetailComponent';

export default {
    layout: {
        sections: ['layouts', 'layout'],
    },
    page: {
        sections: ['pages', 'page', 'images', 'files', 'videos', 'tabs'],
    },
    message: {
        sections: ['messages', 'message'],
    },
    campaign: {
        sections: ['campaigns', 'campaign', 'messages'],
    },
    assets: {
        component: AssetManagerComponent,
        multiple: true,
        storagePanel: true,
        storages: [
            { name: 'assets', icon: 'folder' },
            { name: 'secure_assets', icon: 'lock', description: 'Available for logged in only' },
        ],
    },
    order: {
        component: OrderDetailComponent,
    },
    message: {
        component: MessageDetailComponent,
    },
    'campaign.message': {
        component: MessageDetailComponent,
    },
    'contact.message': {
        component: MessageDetailComponent,
    },
    user: {
        sections: ['users', 'user'],
    },
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/component_mapping.js